/* global chrome */
import React from 'react'
import Images from '../../../images/'
import { useAuth0 } from '../../../services/auth0/useAuth0'
import '../../../styles/style.scss'
import { SocialMediaButton } from './styled'

export const SocialMedia = () => {
  const { initializedAuth0 } = useAuth0()

  const socialMediaLogin = (type) => () => {
    let loginType = 'google'

    if (type === 'facebook') {
      loginType = 'facebook'
    } else if (type === 'apple') {
      loginType = 'apple'
    }
    const options = {
      connection: type,
      redirect_uri: `${process.env.GATSBY_BASE_URL}/callback_popup?auth_type=${loginType}`,
    }
    initializedAuth0.loginWithRedirect(options)

  }

  return (
    <div style={{ marginTop: 24, flexDirection: 'row' }} className="is-flex">
      <SocialMediaButton
        className="button has-text-title"
        onClick={socialMediaLogin('google-oauth2')}
      >
        <Images.GoogleLogo/>
      </SocialMediaButton>
      <div style={{ marginLeft: 8, marginRight: 8 }}/>
      <SocialMediaButton
        onClick={socialMediaLogin('facebook')}
        className="button has-text-title"
      >
        <Images.FacebookLogo/>
      </SocialMediaButton>
      <div style={{ marginLeft: 8, marginRight: 8 }}/>
      <SocialMediaButton
        onClick={socialMediaLogin('apple')}
        className="button has-text-title"
      >
        <Images.AppleLogo/>
      </SocialMediaButton>
    </div>
  )
}